import { AyudaConexion } from '../components/AyudaConexion.jsx'
import {
  AyudaDespliegue, AyudaBaseDatos, AyudaFuncionesLista, AyudaAlmacenamiento, AyudaEnv,
} from '../components/AyudaContrato.jsx'

/**
 * El índice de la ayuda navegable. Cada página sigue registrando su tema contextual con
 * useAyuda(), pero desde CUALQUIER sitio (la home incluida) se puede navegar a todos: el panel
 * enseña este índice debajo del contenido contextual, o solo, si la página no registró nada.
 */
export const TEMAS = [
  { id: 'conectar', titulo: 'Conectar Claude y otros clientes (MCP)', nodo: <AyudaConexion /> },
  { id: 'despliegue', titulo: 'Desplegar: el contrato de una app', nodo: <AyudaDespliegue /> },
  { id: 'basedatos', titulo: 'Base de datos: límites y migraciones', nodo: <AyudaBaseDatos /> },
  { id: 'funciones', titulo: 'Funciones: convenio, webhooks y cron', nodo: <AyudaFuncionesLista /> },
  { id: 'almacenamiento', titulo: 'Almacenamiento S3', nodo: <AyudaAlmacenamiento /> },
  { id: 'variables', titulo: 'Variables de entorno', nodo: <AyudaEnv /> },
]
